import { memo } from "react";

const ActionTop = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 13L10 7L16 13"
      stroke="currentColor"
      strokeWidth="1.45124"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(ActionTop);
